export default __webpack_public_path__ + "static/media/conditions.77c8d702.pdf";